<script setup lang="ts">
import AppNavbarClock from "@/App/components/AppNavbar/AppNavbarClock.vue";
import AppNavbarLinks from "@/App/components/AppNavbar/AppNavbarLinks.vue";
import AppNavbarUser from "@/App/components/AppNavbar/AppNavbarUser.vue";
import UpdateAvailable from "@/App/components/AppNavbar/UpdateAvailable.vue";
import HamburgerMenu from "@/App/components/AppNavbar/HamburgerMenu.vue";
import { useNavbarStore } from "@/App/components/AppNavbar/navigation.store";
import Hamburger from "@/App/components/AppNavbar/Hamburger.vue";
import AppNavbarLinkItems from "@/App/components/AppNavbar/AppNavbarLinkItems.vue";
import AppNavbarMenuItems from "@/App/components/AppNavbar/AppNavbarMenuItems.vue";
import FeedbackItem from "@/App/components/feedback/FeedbackItem.vue";
import { useFeedbackStore } from "@/App/stores";
import CasesNavbarOptions from "@/Pages/Cases/components/CasesNavbar/CasesNavbarOptions.vue";
import WhatsNew from "@/Pages/Cases/components/CasesNavbar/WhatsNew.vue";

const navbarStore = useNavbarStore();
const feedbackForm = useFeedbackStore();
const showFeedbackForm = (): void => {
  feedbackForm.open();
};
</script>

<template>
  <UpdateAvailable></UpdateAvailable>

  <nav class="app-navbar navbar navbar-expand" :style="{ background: navbarStore.color }">
    <div class="app-navbar__container main-content">
      <RouterLink class="brand" :to="navbarStore.defaultRoute">
        <div class="logo">
          <img alt="TigerConnect" src="@/App/assets/logo.png" title="TigerConnect" class="py-2" />
        </div>
      </RouterLink>

      <AppNavbarLinks />

      <div class="ms-auto"></div>

      <FeedbackItem @click="showFeedbackForm" />
      <AppNavbarClock />

      <AppNavbarUser />

      <HamburgerMenu>
        <template #icon>
          <Hamburger />
        </template>
        <template #content>
          <span class="appbar-menu-links">
            <AppNavbarLinkItems />
          </span>
          <AppNavbarMenuItems />
        </template>
      </HamburgerMenu>
      <Teleport to="body">
        <CasesNavbarOptions />
        <WhatsNew />
      </Teleport>
    </div>
  </nav>
</template>

<style scoped>
.app-navbar {
  color: var(--bs-gray-500);
  container-type: inline-size;
  height: 3.5rem;
  z-index: var(--z-index-app-navbar);
}

.app-navbar__container {
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: inherit;
  gap: 1.5rem;
  justify-content: space-between;
  width: 100%;
}

.app-navbar:focus,
.app-navbar:hover {
  color: var(--bs-gray-100);
}

.app-navbar img {
  height: 3.4rem;
  width: auto;
}

.brand {
  text-decoration: none;
}

.appbar-menu-links {
  display: none;
}

@media (max-width: 756px) {
  .appbar-menu-links {
    display: block;
  }
}
</style>
